const { gerarIDUnico, idUnico, isEmpty } = require("./miscellaneous");

export function scrollChat(context) {
    const altura = $(".js-container-chat", context).prop("scrollHeight");
    $(".js-container-chat", context).scrollTop(altura);
}

export function calculaAlturaScroll(context) {
    const altura = $(".js-container-chat:first", context).prop("scrollHeight");
    if (altura > 0) {
        scrollChat(context);
    } else {
        setTimeout(() => {
            calculaAlturaScroll(context);
        }, 200);
    }
}

export function enviaMensagemChat(
    context,
    fileId,
    file,
    fileType,
    extension = null,
    fileName,
    templateInput = null
) {
    let templateId = "";
    if (templateInput != null) {
        templateId = templateInput.val();
    }

    const msg = $(".js-input-chat", context).val() ?? " ";
    if (msg.trim().length < 1 && fileId == undefined && isEmpty(templateId)) {
        return;
    }

    const protocoloId = $(".js-protocolo-id", context).val();
    const oportunidadeId = $(".js-oportunidade-id", context).val();
    const chatRespostaId = $(".js-msg-resposta-id", context).val();
    let configElocaHubId = $(".js-config-eloca-hub", context).val();
    let idProduto = $(".js-id-produto", context).val();
    $(".js-id-produto", context).val('');

    if (!isEmpty(templateId)) {
        configElocaHubId = templateInput.data("config-id");
    }

    $(".js-bloco-mensagem-resposta", context).addClass("d-none");
    $(".js-msg-resposta-id", context).val("");

    //$(".js-sending-chat", context).removeClass("d-none");
    let uniqId = idUnico();
    parseChatMessageUserTemp(
        context,
        protocoloId,
        msg,
        uniqId,
        fileId,
        file,
        fileType
    );

    $.ajax({
        url: siteUrl("/painel/chat"),
        type: "post",
        data: {
            mensagem: msg,
            protocolo_id: protocoloId,
            oportunidade_id: oportunidadeId,
            config_eloca_hub_id: configElocaHubId,
            arquivo: fileId,
            tipo_arquivo: fileType,
            extensao: extension,
            templateId: templateId,
            fileName: fileName,
            chatRespostaId: chatRespostaId,
            idProduto: idProduto,
        },
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
        success: function (res) {
            if (!res.error) {
                if (res.reload) {
                    window.location.reload();
                }

                $(".js-input-chat", context).focus();

                $(res.data).each(function (index, dados) {
                    if (fileId && file) {
                        parseChatMessageUserFile(
                            context,
                            dados,
                            protocoloId,
                            file,
                            fileType,
                            $("." + uniqId, context)
                        );
                    } else {
                        parseChatMessageUser(
                            context,
                            dados,
                            protocoloId,
                            idProduto,
                            $("." + uniqId, context)
                        );
                    }
                });
            } else if (res.message) {
                showToastDanger($("body"), res.message);
                if (res.reload) {
                    window.location.reload();
                    $(".js-input-chat", context).focus();
                }
            }
            //$(".js-input-chat", context).val("");
            //$(".js-input-chat", context).focus();
            //$(".js-sending-chat", context).addClass("d-none");
            //$(".js-input-chat", context).attr("style", "height: 38px");
        },
        error: function (err) {
            $("." + uniqId).remove();
            showToastDanger(
                $("body"),
                "Mensagem não enviada, atualize a página e tente novamente."
            );
            $(".js-sending-chat", context).addClass("d-none");
        },
    });
}

export function parseChatMessageUserTemp(
    context,
    protocoloId,
    msg,
    uniqId,
    fileId,
    file,
    fileType
) {
    if (fileId && file) {
        parseChatMessageUserFile(
            context,
            {
                id: 0,
                mensagem: "",
                user: "Enviando..",
                horario: "",
                fileUrl: null,
                enviado: true,
                programado: 0,
                gupshupId: uniqId,
                resposta_chat_id: null,
            },
            protocoloId,
            file,
            fileType
        );
    } else {
        parseChatMessageUser(
            context,
            {
                id: 0,
                mensagem: msg,
                user: "Enviando..",
                horario: "",
                fileUrl: "",
                enviado: true,
                programado: 0,
                gupshupId: uniqId,
                resposta_chat_id: null,
            },
            protocoloId
        );
    }
    $(".js-input-chat", context).val("");
    $(".js-input-chat", context).focus();
    $(".js-sending-chat", context).addClass("d-none");
    $(".js-input-chat", context).attr("style", "height: 38px");
}

export async function parseChatMessage(context, body, protocoloId, direcao) {
    const msg = body.mensagem;
    let conteudo = "";
    let resposta = showMensagemResposta(msg, context);
    const botoes = showBotoesChat(msg.id, msg.type, direcao);
    switch (msg.type) {
        case "text":
        case "textError":
            conteudo = formatMessage(msg.mensagem);
            break;
        case "postback":
            conteudo = formatMessage(msg.mensagem);
            break;
        case "file":
            let urlCloudFront = false;
            if (!isEmpty(msg.urlCloudFront)) {
                urlCloudFront = msg.urlCloudFront;
            }

            if (msg.fileType == "image") {
                conteudo = `<img class="img-fluid js-imagem-chat imagem-chat" src="${
                    !urlCloudFront ? msg.fileUrl : urlCloudFront
                }" alt="imagem">
                <br />${formatMessage(msg.mensagem)}`;
            } else if (msg.fileType == "file") {
                const nomeArquivo = msg.fileName ?? "Arquivo";
                conteudo = `
                    <a class="btn-link" href="${
                        !urlCloudFront ? msg.fileUrl : urlCloudFront
                    }" target="_blank">
                        <i class="fas fa-paperclip"></i>
                        ${nomeArquivo}
                    </a>
                    <br />${formatMessage(msg.mensagem)}
                `;
            } else if (msg.fileType == "audio") {
                conteudo = `
                    <audio controls>
                        <source src="${
                            !urlCloudFront ? msg.fileUrl : urlCloudFront
                        }" type="audio/mpeg">
                    </audio>
                    <br />${formatMessage(msg.mensagem)}
                `;
            } else if (msg.fileType == "video") {
                conteudo = `
                    <video controls width="100%">
                        <source src="${
                            !urlCloudFront ? msg.fileUrl : urlCloudFront
                        }" type="video/mp4">
                    </video>
                    <br />${formatMessage(msg.mensagem)}
                `;
            }
            break;
        case "sticker":
            urlCloudFront = false;
            if (!isEmpty(msg.urlCloudFront)) {
                urlCloudFront = msg.urlCloudFront;
            }
            conteudo = `<img class="img-fluid" src="${
                !urlCloudFront ? msg.fileUrl : urlCloudFront
            }" alt="imagem">`;
            break;
        case "list":
            const list = JSON.parse(msg.mensagem);
            let tituloLista = "<em>Sem título</em>";
            if (list.text) {
                tituloLista = `<em>${list.text}</em>`;
            }
            let subTituloLista = "Lista";
            if (list.listOptionsTitle) {
                subTituloLista = list.listOptionsTitle;
            }
            let botoesLista = "";
            if (list.buttons && list.buttons.length) {
                list.buttons.forEach(function (button) {
                    botoesLista += `<span>${button.title}</span><br/>`;
                });
            }

            conteudo = `
                <strong>${tituloLista}</strong> <br/>
                <small>${subTituloLista}:</small> <br/>
                ${botoesLista}
            `;
            break;
        case "button":
            const botoesMsg = JSON.parse(msg.mensagem);
            let titulo = "<em>Sem título</em>";
            if (botoesMsg.text) {
                titulo = `<em>${botoesMsg.text}</em>`;
            }
            let botoes = "";
            if (botoesMsg.buttons && botoesMsg.buttons.length) {
                botoesMsg.buttons.forEach(function (button) {
                    botoes += `<span>${button.title}</span><br/>`;
                });
            }

            conteudo = `
                <strong>${titulo}</strong> <br/>
                ${botoes}
            `;
            break;
        case "contact":
            let id = gerarIDUnico();
            const mensagem = JSON.parse(msg.mensagem);
            if (Array.isArray(mensagem)) {
                conteudo = `
                    <div class="row">`;
                mensagem.forEach(function (item) {
                    item.telefones.forEach(function (telefone) {
                        id = gerarIDUnico();
                        conteudo += `
                        <div class="col-2" style="font-size: 2em;">
                            <i class="fas fa-user fa-fw"  aria-hidden="true"></i>
                        </div>
                        <div class="col" id="cliente_contato${id}">
                            ${item.nome}
                            <br>
                            ${telefone}
                        </div>
                        <div class="col-12 mt-2">
                            <p class="text-center" style="margin: 0">
                                <button class="btn btn-link js-salvar-contato" id="btnSalvarCliente${id}" data-id="${id}" style="font-weight: bold; font-size: 0.8rem">
                                    Salvar <i class="fa fa-save" aria-hidden="true"></i>
                                </button>
                                <div id="salvarClientLoading${id}" class="mt d-none">
                                    <p class="text-center"><i class="fa fa-spinner fa-spin fa-3x fa-fw"></i></p>
                                </div>
                            </p>
                        </div>
                    `;
                    });
                });
                conteudo += `</div>`;
            } else {
                conteudo = `
                    <div class="row">
                        <div class="col-2">
                            <i class="fas fa-user fa-fw"  aria-hidden="true"></i>
                        </div>
                        <div class="col" id="cliente_contato${id}">
                        ${mensagem}
                        </div>
                        <div class="col-12 mt-2">
                            <p class="text-center" style="margin: 0">
                                <button class="btn btn-link js-salvar-contato" id="btnSalvarCliente${id}" data-id="${id}" style="font-weight: bold; font-size: 0.8rem">
                                    Salvar <i class="fa fa-save" aria-hidden="true"></i>
                                </button>
                                <div id="salvarClientLoading${id}" class="mt d-none">
                                    <p class="text-center"><i class="fa fa-spinner fa-spin fa-3x fa-fw"></i></p>
                                </div>
                            </p>
                        </div>
                    </div>
                `;
            }

            break;
    }
    let html = "";
    let seletor = "";
    let mediaCaption = "";
    if (
        typeof msg.media_caption !== "undefined" &&
        msg.media_caption !== null
    ) {
        mediaCaption = msg.media_caption + "<br/>";
    }

    if (direcao == "in") {
        const reacoesChat = $("#js-template-reacoes-chat")
            .html()
            .replaceAll("xxx", msg.id);
        html = `
            <div class="mensagem mensagem__cliente ${msg.ref} js-chat-mensagem" id="js-mensagem-${msg.id}">
                <div class="mensagem-bloco">
                    <div class="arrow"></div>
                    ${resposta}
                    ${reacoesChat}
                    <div class="mensagem__conteudo">
                        ${botoes}
                        ${conteudo}
                    </div>
                    ${mediaCaption}
                    <div class="horario">${body.horario}</div>
                    <div class="mensagem__reacao js-mensagem-reacao d-none">
                        <div class="reacao">
                            <span class="js-reacao-cliente"></span>
                            <span class="js-reacao-user"></span>
                        </div>
                    </div>
                </div>
            </div>
        `;
        seletor = `#protocolo-${protocoloId} div.mensagem.mensagem__cliente:last`;
    } else {
        html = `
            <div class="mensagem mensagem__usuario js-chat-mensagem">
                <div class="mensagem-bloco">
                    <div class="mensagem__conteudo">
                        ${botoes}
                        ${conteudo}
                    </div>
                    ${mediaCaption}
                    <div class="horario">
                        <span class="text-left font-italic mr-2">
                            ${body.mensagem.user ? body.mensagem.user.name : 'Bot'}
                        </span>
                        ${body.horario}
                        <span class="js-status-message ${body.gupshupId}-enviada d-none"><i class="fa fa-check" title="Mensagem enviada"></i></span>
                        <span class="js-status-message ${body.gupshupId}-entregue  d-none"><i class="fa fa-check-double" title="Mensagem entregue ao destinatário"></i></span>
                        <span class="js-status-message ${body.gupshupId}-lida  d-none"><i class="fa fa-check-double text-primary" title="Mensagem lida"></i></span>
                    </div>
                    <div class="mensagem__reacao js-mensagem-reacao d-none">
                        <div class="reacao">
                            <span class="js-reacao-cliente"></span>
                            <span class="js-reacao-user"></span>
                        </div>
                    </div>
                    <div class="arrow"></div>
                </div>
            </div>
        `;
        seletor = `#protocolo-${protocoloId} div.mensagem.mensagem__usuario:last`;
    }
    $(".js-aguardando-resposta", context).remove();
    $(`.js-container-chat #protocolo-${protocoloId}`, context).append(html);
    Eloca.load($(seletor));

    scrollChat(context);
}

export function parseChatMessageUser(
    context,
    dados,
    protocoloId,
    idProduto,
    replaceId = false
) {
    const msg = formatMessage(dados.mensagem, idProduto);
    let alert = "";
    const resposta = showMensagemResposta(dados, context);
    const botoes = showBotoesChat(dados.id, "text", "out");

    if (!dados.enviado && !dados.programado) {
        alert = `
                <span class="font-italic small text-danger font-weight-bold">
                    <i class="fas fa-exclamation-circle"></i> Mensagem não enviada
                </span>
            `;
    } else if (dados.programado) {
        alert = `
                <span class="font-italic small text-primary font-weight-bold">
                    <i class="fas fa-exclamation-circle"></i> Aguardando resposta do cliente
                </span>
            `;
    }
    const msgId = `js-mensagem-${dados.id}`;
    let html = `
            <div class="mensagem mensagem__usuario ${dados.gupshupId} js-chat-mensagem" id="${msgId}">
                <div class="mensagem-bloco">
                    ${resposta}
                    <div class="mensagem__conteudo">
                        ${botoes}
                        ${msg}
                    </div>
                    <div class="horario">
                        <span class="text-left font-italic mr-2">
                            ${dados.user}
                        </span>
                        ${dados.horario}
                        <span class="js-status-message ${dados.gupshupId}-enviada d-none"><i class="fa fa-check" title="Mensagem enviada"></i></span>
                        <span class="js-status-message ${dados.gupshupId}-entregue  d-none"><i class="fa fa-check-double" title="Mensagem entregue ao destinatário"></i></span>
                        <span class="js-status-message ${dados.gupshupId}-lida  d-none"><i class="fa fa-check-double text-primary" title="Mensagem lida"></i></span>
                    </div>
                    <div class="mensagem__reacao js-mensagem-reacao d-none">
                        <div class="reacao">
                            <span class="js-reacao-cliente"></span>
                            <span class="js-reacao-user"></span>
                        </div>
                    </div>
                    ${alert}
                    <div class="arrow"></div>
                </div>
            </div>
       `;

    if (replaceId) {
        replaceId.html(html);
    } else {
        $(`.js-container-chat #protocolo-${protocoloId}`, context).append(html);
    }

    Eloca.load($(`#${msgId}`));

    scrollChat(context);
}

export function writeFileInChat(context, html, protocoloId, replace = false) {
    if (replace) {
        replace.html(html);
    } else {
        $(`.js-container-chat #protocolo-${protocoloId}`, context).append(html);
    }
}

export function parseChatMessageUserFile(
    context,
    dados,
    protocoloId,
    file,
    fileType,
    replaceId
) {
    if (fileType == "image") {
        const reader = new FileReader();
        reader.onload = function (e) {
            let alert = "";
            if (!dados.enviado && !dados.programado) {
                alert = `
                    <span class="font-italic small text-danger font-weight-bold">
                        <i class="fas fa-exclamation-circle"></i> Mensagem não enviada
                    </span>
                `;
            } else if (dados.programado) {
                alert = `
                    <span class="font-italic small text-primary font-weight-bold">
                        <i class="fas fa-exclamation-circle"></i> Aguardando resposta do cliente
                    </span>
                `;
            }
            let html = `
            <div class="mensagem mensagem__usuario ${dados.gupshupId}" id="${dados.gupshupId}">
                <div class="mensagem-bloco">
                    <div class="mensagem__conteudo">
                        <img class="img-fluid js-imagem-chat imagem-chat" src="${e.target.result}" alt="Imagem">
                    </div>
                    <div class="horario">
                        <span class="text-left font-italic mr-2">
                            ${dados.user}
                        </span>
                        ${dados.horario}
                        <span class="js-status-message ${dados.gupshupId}-enviada d-none"><i class="fa fa-check" title="Mensagem enviada"></i></span>
                        <span class="js-status-message ${dados.gupshupId}-entregue  d-none"><i class="fa fa-check-double" title="Mensagem entregue ao destinatário"></i></span>
                        <span class="js-status-message ${dados.gupshupId}-lida  d-none"><i class="fa fa-check-double text-primary" title="Mensagem lida"></i></span>
                    </div>
                    <div class="mensagem__reacao js-mensagem-reacao d-none">
                        <div class="reacao">
                            <span class="js-reacao-cliente"></span>
                            <span class="js-reacao-user"></span>
                        </div>
                    </div>
                    ${alert}
                    <div class="arrow"></div>
                </div>
            </div>
        `;
            Eloca.load(html);
            writeFileInChat(context, html, protocoloId, replaceId);
            scrollChat(context);
        };
        reader.readAsDataURL(file);
    } else if (fileType == "video") {
        const reader = new FileReader();
        reader.onload = function (e) {
            let html = `
                <div class="mensagem mensagem__usuario ${dados.gupshupId}" id="${dados.gupshupId}">
                    <div class="mensagem-bloco">
                        <div class="mensagem__conteudo">`;
            if (dados.fileUrl != "" && dados.fileUrl != null) {
                html += `<video controls width="100%">
                                    <source src="${dados.fileUrl}" type="video/mp4">
                            </video>`;
            } else {
                html += `Aguarde, preparando o vídeo..`;
            }
            html += `</div>
                        <div class="horario">
                            <span class="text-left font-italic mr-2">
                                ${dados.user}
                            </span>
                            ${dados.horario}
                            <span class="js-status-message ${dados.gupshupId}-enviada d-none"><i class="fa fa-check" title="Mensagem enviada"></i></span>
                            <span class="js-status-message ${dados.gupshupId}-entregue  d-none"><i class="fa fa-check-double" title="Mensagem entregue ao destinatário"></i></span>
                            <span class="js-status-message ${dados.gupshupId}-lida  d-none"><i class="fa fa-check-double text-primary" title="Mensagem lida"></i></span>
                        </div>
                        <div class="mensagem__reacao js-mensagem-reacao d-none">
                            <div class="reacao">
                                <span class="js-reacao-cliente"></span>
                                <span class="js-reacao-user"></span>
                            </div>
                        </div>
                        <div class="arrow"></div>
                    </div>
                </div>
        `;
            Eloca.load(html);
            writeFileInChat(context, html, protocoloId, replaceId);
            scrollChat(context);
        };
        reader.readAsDataURL(file);
    } else if (fileType == "audio") {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
            let html = `
            <div class="mensagem mensagem__usuario ${dados.gupshupId}" id="${dados.gupshupId}">
                <div class="mensagem-bloco">
                    <div class="mensagem__conteudo">
                        <audio controls>
                            <source src="${e.target.result}">
                        </audio>
                    </div>
                    <div class="horario">
                        <span class="text-left font-italic mr-2">
                            ${dados.user}
                        </span>
                        ${dados.horario}
                        <span class="js-status-message ${dados.gupshupId}-enviada d-none"><i class="fa fa-check" title="Mensagem enviada"></i></span>
                        <span class="js-status-message ${dados.gupshupId}-entregue  d-none"><i class="fa fa-check-double" title="Mensagem entregue ao destinatário"></i></span>
                        <span class="js-status-message ${dados.gupshupId}-lida  d-none"><i class="fa fa-check-double text-primary" title="Mensagem lida"></i></span>
                    </div>
                    <div class="mensagem__reacao js-mensagem-reacao d-none">
                        <div class="reacao">
                            <span class="js-reacao-cliente"></span>
                            <span class="js-reacao-user"></span>
                        </div>
                    </div>
                    <div class="arrow"></div>
                </div>
            </div>
        `;
            Eloca.load(html);
            writeFileInChat(context, html, protocoloId, replaceId);
            scrollChat(context);
        };
    } else if (fileType == "file") {
        const nomeArquivo = file.name ?? "Arquivo";
        let html = `
            <div class="mensagem mensagem__usuario ${dados.gupshupId} js-chat-mensagem" id="js-mensagem-${dados.id}">
                <div class="mensagem-bloco">
                    <div class="mensagem__conteudo">`;
        if (dados.fileUrl != "" && dados.fileUrl != null) {
            html += `<a class="btn-link" href="${dados.fileUrl}" target="_blank">
                            <i class="fas fa-paperclip"></i>
                            ${nomeArquivo}
                            </a>`;
        } else {
            html += `Aguarde, preparando o arquivo..`;
        }
        html += `
                    </div>
                    <div class="horario">
                        <span class="text-left font-italic mr-2">
                            ${dados.user}
                        </span>
                        ${dados.horario}
                        <span class="js-status-message ${dados.gupshupId}-enviada d-none"><i class="fa fa-check" title="Mensagem enviada"></i></span>
                        <span class="js-status-message ${dados.gupshupId}-entregue  d-none"><i class="fa fa-check-double" title="Mensagem entregue ao destinatário"></i></span>
                        <span class="js-status-message ${dados.gupshupId}-lida  d-none"><i class="fa fa-check-double text-primary" title="Mensagem lida"></i></span>
                    </div>
                    <div class="mensagem__reacao js-mensagem-reacao d-none">
                        <div class="reacao">
                            <span class="js-reacao-cliente"></span>
                            <span class="js-reacao-user"></span>
                        </div>
                    </div>
                    <div class="arrow"></div>
                </div>
            </div>
        `;
        Eloca.load(html);
        writeFileInChat(context, html, protocoloId, replaceId);
        scrollChat(context);
    }
}

export function showMensagemResposta(msg, context) {
    let resposta = "";
    if (
        msg.resposta_chat_id &&
        $(`#js-mensagem-${msg.resposta_chat_id} .mensagem__conteudo`, context)
            .length
    ) {
        resposta = $(
            `#js-mensagem-${msg.resposta_chat_id} .mensagem__conteudo`,
            context
        ).html();
    }

    if (resposta) {
        return `
            <div class="mensagem__resposta">
                <a href="#js-mensagem-${msg.resposta_chat_id}">
                    ${resposta}
                </a>
            </div>
        `;
    }

    return "";
}

export function showBotoesChat(id, tipo, direcao) {
    let encaminhar = "";
    let responder = "";
    if (tipo != "contato") {
        encaminhar = `<a
            class="dropdown-item js-btn-encaminhar-msg btn-link pl-2"
            href="javascript:void(0)"
            title="Encaminhar mensagem"
            data-chat-id="${id}"
        >
            <i class="fas fa-share mr-1"></i> Encaminhar
        </a>`;
    }
    if (direcao == "in") {
        responder = `
            <a
                class="dropdown-item js-btn-responder-msg btn-link pl-2"
                href="javascript:void(0)"
                title="Responder mensagem"
                data-chat-id="${id}"
            >
                <i class="fas fa-reply mr-1"></i> Responder
            </a>
        `;
    }

    return `<div class="dropdown dropdown-menu-chat d-none js-dropdown-menu-chat">
        <a
            class="btn-link dropdown-toggle"
            href="#"
            role="button"
            data-toggle="dropdown"
            aria-expanded="false"
        >
            <i class="fas fa-chevron-down"></i>
        </a>

        <div class="dropdown-menu">
            ${encaminhar}
            ${responder}
        </div>
    </div>`;
}

export function formatMessage(mensagem, idProduto = null) {
    if (mensagem.includes("location|", 0)) {
        const loc = mensagem.split("|");
        if (loc.length == 3) {
            return `<iframe src="https://www.google.com/maps/?q=${loc[1]},${loc[2]}&hl=pt-br&z=15&output=embed"></iframe>`;
        }
    }

    const regexCode = /(\```)(.*)(\```)/gims;
    const subCode = `<code>$2</code>`;
    let text = mensagem.replaceAll(regexCode, subCode);

    const regexItalic = /(\_)(.*)(\_)/gims;
    const subItalic = `<em>$2</em>`;
    text = text.replaceAll(regexItalic, subItalic);

    const regexNegrito = /(\*)(.*)(\*)/gims;
    const subNegrito = `<strong>$2</strong>`;
    text = text.replaceAll(regexNegrito, subNegrito);

    const regexTachado = /(\~)(.*)(\~)/gims;
    const subTachado = `<del>$2</del>`;
    text = text.replaceAll(regexTachado, subTachado);

    /*const regexUrl = /(https?:\/\/[^\s]+)/g;
        text = text.replace(regexUrl, function (url) {
            return `<a target=\"_blank\" href=\"${url}\">link</a>`;
        });*/

    if (idProduto) {
        text = `<u class="add-produto-mensagem js-add-produto-mensagem" data-id="${idProduto}">${text}</u>`;
    }

    text.replace(/(https?:\/\/[^\s]+)/g, "<a href='$1'>$1</a>");

    return text;
}

export function colarImagemChat(context, event) {
    const clipboardItems = event.originalEvent.clipboardData.items;
    const items = [].slice.call(clipboardItems).filter(function (item) {
        return item.type.indexOf("image") !== -1;
    });
    if (items.length === 0) {
        return;
    }
    event.preventDefault();
    $(".js-input-chat", context).val("");

    const item = items[0];
    const blob = item.getAsFile();

    $("#modalPreview").modal();
    $("#js-preview-imagem").attr("src", URL.createObjectURL(blob));

    let file = new File([blob], "fileName.jpg", {
        type: "image/jpeg",
    });
    const tipo = "image";

    $(".js-enviar-imagem-colada", $("#modalPreview")).unbind("click");
    $(".js-enviar-imagem-colada", $("#modalPreview")).on("click", function () {
        $(".js-sending-chat", context).removeClass("d-none");

        Vapor.store(file, {
            baseURL: siteUrl("/painel"),
            progress: (progress) => {
                this.uploadProgress = Math.round(progress * 100);
            },
        })
            .then((response) => {
                enviaMensagemChat(context, response.uuid, file, tipo);
            })
            .catch((error) => {
                alert("Não foi possível enviar a imagem");
                $(".js-sending-chat", context).addClass("d-none");
            });
    });
}

export function previewAudio(recorder, context) {
    recorder
        .getMp3()
        .then(([buffer, blob]) => {
            const file = new File(buffer, "audio.mp3", {
                type: "audio/mpeg",
                lastModified: Date.now(),
            });

            const audio = document.createElement("audio");
            audio.src = URL.createObjectURL(file);
            audio.controls = true;
            $(".js-conteudo-audio", context).html(audio);

            $(".js-btn-enviar-audio", context).unbind("click");
            $(".js-btn-enviar-audio", context).on("click", function () {
                enviarAudio(file, blob, context);
            });
        })
        .catch((e) => {
            alert("Não foi possível converter o áudio");
            console.log(e);
        });
}

export function enviarAudio(file, blob, context) {
    $(".js-sending-chat", context).removeClass("d-none");

    Vapor.store(file, {
        baseURL: siteUrl("/painel"),
    })
        .then((response) => {
            $(".js-btn-close-audio", context).trigger("click");
            enviaMensagemChat(context, response.uuid, blob, "audio");
        })
        .catch((error) => {
            console.error(error);
            $(".js-sending-chat", context).addClass("d-none");
            alert("Aconteceu um erro ao tentar salvar o áudio");
        });
}

export function showBlocoChatAudio(context) {
    $(".js-bloco-texto", context).addClass("d-none");
    $(".js-bloco-audio", context).removeClass("d-none");
    $(".js-conteudo-audio", context).html(
        '<svg width="200" height="40" version="1.1" viewBox="0 0 117.61 29.606" xmlns="http://www.w3.org/2000/svg"><g transform="translate(41.86 40.742)"><><rect id="line_1" x="-28.532" y="-40.742" width="2.0944" height="27.93" rx="0" ry=".9083" style="fill:#666;stroke-width:0" /><rect id="line_2" x="-24.089" y="-38.133" width="2.0944" height="23.755" rx="0" ry=".77254" style="fill:#666;stroke-width:0" /><rect id="line_3" x="-32.975" y="-38.615" width="2.0944" height="23.755" rx="0" ry=".77254" style="fill:#666;stroke-width:0" /><rect id="line_4" x="-10.761" y="-40.221" width="2.0944" height="27.93" rx="0" ry=".9083" style="fill:#666;stroke-width:0" /><rect id="line_5" x="-6.3178" y="-37.612" width="2.0944" height="23.755" rx="0" ry=".77254" style="fill:#666;stroke-width:0" /><rect id="line_6" x="-15.203" y="-38.094" width="2.0944" height="23.755" rx="0" ry=".77254" style="fill:#666;stroke-width:0" /><rect id="line_7" x="-19.646" y="-36.151" width="2.0944" height="20.223" rx="0" ry=".65766" style="fill:#666;stroke-width:0" /><rect id="line_8" x="-37.418" y="-37.09" width="2.0944" height="20.223" rx="0" ry=".65766" style="fill:#666;stroke-width:0" /><rect id="line_9" x="-1.875" y="-35.083" width="2.0944" height="17.975" rx="0" ry=".58456" style="fill:#666;stroke-width:0" /><rect id="line_10" x="2.5678" y="-33.583" width="2.0944" height="15.302" rx="0" ry=".49763" style="fill:#666;stroke-width:0" /><rect id="line_11" x="-41.86" y="-34.738" width="2.0944" height="15.302" rx="0" ry=".49763" style="fill:#666;stroke-width:0" /><rect id="line_12" x="15.896" y="-39.587" width="2.0944" height="27.93" rx="0" ry=".9083" style="fill:#666;stroke-width:0" /><rect id="line_13" x="20.339" y="-36.978" width="2.0944" height="23.755" rx="0" ry=".77254" style="fill:#666;stroke-width:0" /><rect id="line_14" x="11.453" y="-37.46" width="2.0944" height="23.755" rx="0" ry=".77254" style="fill:#666;stroke-width:0" /><rect id="line_15" x="33.668" y="-39.066" width="2.0944" height="27.93" rx="0" ry=".9083" style="fill:#666;stroke-width:0" /><rect id="line_16" x="38.11" y="-36.457" width="2.0944" height="23.755" rx="0" ry=".77254" style="fill:#666;stroke-width:0" /><rect id="line_17" x="29.225" y="-36.939" width="2.0944" height="23.755" rx="0" ry=".77254" style="fill:#666;stroke-width:0" /><rect id="line_18" x="24.782" y="-34.996" width="2.0944" height="20.223" rx="0" ry=".65766" style="fill:#666;stroke-width:0" /><rect id="line_19" x="7.0106" y="-35.935" width="2.0944" height="20.223" rx="0" ry=".65766" style="fill:#666;stroke-width:0" /><rect id="line_20" x="42.553" y="-33.927" width="2.0944" height="17.975" rx="0" ry=".58456" style="fill:#666;stroke-width:0" /><rect id="line_21" x="46.996" y="-32.428" width="2.0944" height="15.302" rx="0" ry=".49763" style="fill:#666;stroke-width:0" /><rect id="line_22" x="60.325" y="-39.74" width="2.0944" height="27.93" rx="0" ry=".9083" style="fill:#666;stroke-width:0" /><rect id="line_23" x="64.767" y="-37.131" width="2.0944" height="23.755" rx="0" ry=".77254" style="fill:#666;stroke-width:0" /><rect id="line_24" x="55.882" y="-37.613" width="2.0944" height="23.755" rx="0" ry=".77254" style="fill:#666;stroke-width:0" /><rect id="line_25" x="51.439" y="-35.67" width="2.0944" height="20.223" rx="0" ry=".65766" style="fill:#666;stroke-width:0" /><rect id="line_26" x="69.21" y="-34.602" width="2.0944" height="17.975" rx="0" ry=".58456" style="fill:#666;stroke-width:0" /><rect id="line_27" x="73.653" y="-33.102" width="2.0944" height="15.302" rx="0" ry=".49763" style="fill:#666;stroke-width:0" /></></g></svg>'
    );
    $(".js-btn-stop-audio", context).removeClass("d-none");
    $(".js-btn-enviar-audio", context).addClass("d-none");
}

export function inputsConfigWhatsAppShowHide(select) {
    if (!$(select).length) {
        return;
    }
    if ($(select).val() != "1") {
        //!= gupshup
        $(".js-div-config-ws").show();
        $(".js-div-config-gupshup").hide();
        $(".js-servidor-ws").prop("required", true);
        $(".js-div-config-gupshup").each(function () {
            $(this).find("input").prop("disabled", true);
            $(this).find("select").prop("disabled", true);
        });
        $(".js-div-config-ws").each(function () {
            $(this).find("input").prop("disabled", false);
            $(this).find("select").prop("disabled", false);
        });
    } else {
        $(".js-div-config-ws").hide();
        $(".js-div-config-gupshup").show();
        $(".js-servidor-ws").prop("required", false);
        $(".js-div-config-gupshup").each(function () {
            $(this).find("input").prop("disabled", false);
            $(this).find("select").prop("disabled", false);
        });
        $(".js-div-config-ws").each(function () {
            $(this).find("input").prop("disabled", true);
            $(this).find("select").prop("disabled", true);
        });
    }
}
